<template>
	<div class="source-code-list-wrapper">
		<EmptyPage 
			v-if="sourceCodeList.length === 0" 
			:height="480" 
			:loading="loading" />
		<div v-else>
			<div class="source-code-list">
				<div 
					class="source-code-list-item" 
					v-for="(item, index) in sourceCodeList" 
					:key="index">
					<SourceCodeCard 
						:sourceCode="item" 
						@set-source-code="setSourceCode" 
						:user="user" />
				</div>
			</div>
			<div 
				class="loading" 
				v-show="scrollLoading">
				<i class="el-icon-loading"></i>
			</div>
			<!-- 分页 -->
			<div class="source-code-list__pagination">
				<el-pagination
					background
					layout="prev, pager, next"
					:hide-on-single-page="true"
					:page-size="pageSize"
					:current-page="pageNum"
					:total="total"
					@current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<!-- <material-detail v-if="material" :material.sync="material" @updateMaterialList="updateMaterialList"></material-detail> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { getSourceCodeList, getSourceCodePayed, getSourceCodeByAuthor, getMyCollectSourceCode } from '@/api/sourceCode';
import { openWindow } from '@/utils/utils';
import SourceCodeCard from './SourceCodeCard';
import EmptyPage from '@/components/EmptyPage';
export default {
	name: 'SourceCodeList',
    components: {
		SourceCodeCard,
		EmptyPage
    },
    props: {
		// 各项标签
        tab: {
            type: Object,
            default: () => {}
		},
		// 素材类型【1：免费素材】
		materialType: {
			type: String,
			default: '1'
		},
		// 素材归属用户
		user: {
			type: Object,
			required: false
		},
		// 是否是已收藏素材
		collected: {
			type: Boolean,
			required: false
		},
		type: {
			type: [String, Number],
			required: false
		},

		author: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	inject:['backTop'],
	data() {
		return {
			loading: false,
			scrollLoading: false,
			total: 0,
			pageSize: 40,
			pageNum: 1,
			pages: 1,
			// 源码列表
			sourceCodeList: [],
			// 需要显示详情的源码
			material: null,
		}
	},
    computed: {
        ...mapState('app', ['scrollStatus']),
		...mapState("user", ["userInfo"]),
    },
	watch: {
		tab: {
			deep: true,
            immediate:true,
			handler(newVal, oldVal) {
				// Object.assign(this.$data, this.$options.data.call(this));
				this.sourceCodeList = [];
				this.total = 0;
				this.pageSize = 40;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pageNum = 1;
				this.pages = 1;
				// if((this.$route.params.type || this.$route.params.subType) && !newVal.categoryOne) {
				// 	return
				// }
				if (!this.loading){
					this.getSourceCode();
				}
			}
		},
		// scrollStatus() {
		// 	if (!this.user && !this.scrollLoading) {
		// 		this.scroll();
		// 	}
		// },
		type:{
			immediate:true,
			handler(newVal, oldVal) {
				this.sourceCodeList = [];
				this.total = 0;
				this.pageSize = 40;
				this.pageNum =  1;
				// this.pageNum = sessionStorage.getItem(this.$route.path) || 1;
				this.pages = 1;
				if (!this.loading && newVal){
					this.getSourceCode();
				}
			}
		}
		// material: {
		// 	deep: true,
		// 	handler(val) {
		// 		if (!val) {
		// 			this.pageNum = 1;
		// 			this.getSourceCode();
		// 		}
		// 	}
		// },
	},
	created() {
		// this.pageNum = sessionStorage.getItem(this.$route.path) || 1
		// this.getSourceCode();
	},
	methods: {
		handlePageChange(pageNum) {
			sessionStorage.setItem(this.$route.path,pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getSourceCode();
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getSourceCode();
        },
		// 获取素材
		getSourceCode() {
			this.loading = true;
			let queryAjax;
					
			switch (this.type) {
				case 'order':
					queryAjax = getSourceCodePayed
					break;

				case 'collection':
					queryAjax = getMyCollectSourceCode
					break;

				case 'author':
					queryAjax = getSourceCodeByAuthor
					break;

				default:
					queryAjax = getSourceCodeList
					break;
			}

			let params = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
			}
			if (['order', 'collection'].includes(this.type)) {
				params.userId = this.userInfo.id
			} else {
				params = {
					...params,
					...{
						author: (this.tab || {}).author || '',
						categoryOne: this.tab.categoryOne === 'null' ? '' : this.tab.categoryOne || '',
						categoryTwo: this.tab.categoryTwo === 'o' ? '' : this.tab.categoryTwo || '',
						techId: this.tab.techId === 'o' ? '' : this.tab.techId || '',
					}
				}
			}

			queryAjax(params).then(({ data,total }) => {
				console.log('data: ', data);
				let _data = data
				if (['order', 'collection', 'author'].includes(this.type)) {
					_data = data.result || data
				}
				if (this.scrollLoading) {
					this.sourceCodeList.push(..._data);
				} else {
					this.sourceCodeList = _data;
				}
				this.total = total || _data.length;
				// this.pages = _data.pages || 1;
				this.sourceCodeList.forEach(item => {
					item.formatList = item.categoryList&& item.categoryList.length ? (item.categoryList[0].techChildList || []).map(subItme => ({name:(subItme.categoryName||'').toLowerCase()})) : []
				})
				
			}).finally(() => {
				this.loading = false;
				this.scrollLoading = false;
			});
		},
		setSourceCode(sourceCode) {
			if (!sourceCode.id) {
				return;
			}
			openWindow(`/#/sourceCode/detail/${sourceCode.id}`)
		}
	}
}
</script>

<style lang="scss" scoped>
.source-code-list {

    &-item {
        display: inline-block;
        margin-right: 28px;
        margin-top: 32px;
        width: 296px;
		&:nth-child(5n) {
			margin-right: 0;
		}
    }
	&__pagination {
        margin-top: 45px;
		padding-bottom: 30px;
        text-align: center;
    }
}
.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}
@include mq($small) {
    .source-code-list {
        padding-top: 15px;
        &-item {
            // margin-right: 10px;
            // margin-top: 10px;
			width: 272px;
			&:nth-child(4n) {
				margin-right: 28px;
			}
			&:nth-child(5n) {
				margin-right: 28px;
			}
        }
    }
}
</style>
